import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/info.svg'


const _withScopeId = n => (_pushScopeId("data-v-628eab04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "insight-engagement-spotlight-list-card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Team Members", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "engagement-spotlight-info",
  class: "title"
}, [
  /*#__PURE__*/_createTextVNode(" Engagement "),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "badge" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_BestWorstTopicTag = _resolveComponent("BestWorstTopicTag")!
  const _component_InsightsEngagementListItem = _resolveComponent("InsightsEngagementListItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(['header', { wide: _ctx.wideLayout }])
    }, _hoisted_4, 2),
    (_ctx.spotlightTeam && _ctx.spotlightTeam.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamUsers, (teamUser, i) => {
            return (_openBlock(), _createBlock(_component_InsightsEngagementListItem, {
              key: teamUser.id,
              selected: 
                    _ctx.wideLayout &&
                    teamUser.id === _ctx.desktopEngagementUserIdSelected
                ,
              title: teamUser.name,
              "show-chevron": _ctx.showChevron,
              "wide-layout": _ctx.wideLayout,
              description: _ctx.tileDescription(teamUser),
              class: _normalizeClass(_ctx.getListBorder(i, _ctx.teamUsers.length, teamUser.id)),
              "delta-positive": _ctx.tilePercentageChange(teamUser) > 0,
              "previous-percentage": _ctx.tilePercentagePrevious(teamUser),
              percentage: _ctx.tilePercentage(teamUser),
              score: Math.abs(_ctx.tilePercentageChange(teamUser)),
              onClick: ($event: any) => (_ctx.onClickTeamMember(teamUser, i))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_AvatarOrInitials, {
                  size: 44,
                  user: _ctx.userDetails(teamUser)
                }, null, 8, ["user"])
              ]),
              badge: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  (teamUser.recursive_data)
                    ? (_openBlock(), _createBlock(_component_BestWorstTopicTag, {
                        key: 0,
                        positive: 
                                _ctx.themeWithMostChange(teamUser)
                                    .change_in_term_data.score > 0
                            ,
                        title: _ctx.themeWithMostChange(teamUser).name
                      }, null, 8, ["positive", "title"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["selected", "title", "show-chevron", "wide-layout", "description", "class", "delta-positive", "previous-percentage", "percentage", "score", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}